export default __webpack_public_path__ + "static/media/scheduled-calls-tab.b8807f04.png";